import React from 'react';
import { cx } from '@emotion/css';
import type { IconProps } from '../Icon';
import { Black } from '../constants/colors';
import { Sizes } from '../constants/sizes';

const CartIcon = (props: IconProps): JSX.Element => {
  const {
    className,
    'data-testid': dataTestId,
    fill = Black.V100,
    size = Sizes.Medium,
    onClick,
    onMouseEnter,
    onMouseLeave,
  } = props;
  const classNames = cx('sds-icon', 'sds-icon-cart', className);
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
      className={classNames}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid={dataTestId}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.26404 4.75H14.7359L13.129 11.6033H4.87092L3.26404 4.75ZM4.73589 5.91667L5.79568 10.4367H12.2042L13.264 5.91667H4.73589Z'
      />
      <path d='M11.66 14.1533C12.2123 14.1533 12.66 13.7056 12.66 13.1533C12.66 12.6011 12.2123 12.1533 11.66 12.1533C11.1077 12.1533 10.66 12.6011 10.66 13.1533C10.66 13.7056 11.1077 14.1533 11.66 14.1533Z' />
      <path d='M6.23328 14.1533C6.78556 14.1533 7.23328 13.7056 7.23328 13.1533C7.23328 12.6011 6.78556 12.1533 6.23328 12.1533C5.68099 12.1533 5.23328 12.6011 5.23328 13.1533C5.23328 13.7056 5.68099 14.1533 6.23328 14.1533Z' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.72501 3.49011L3.71834 3.53011C3.98457 3.53545 4.21339 3.72041 4.27443 3.9796L5.9011 10.8863L4.7655 11.1537L3.24256 4.68747L1.7016 4.65654L1.72501 3.49011Z'
      />
      <path fillRule='evenodd' clipRule='evenodd' d='M4.66663 7.56999H13.3333V8.73666H4.66663V7.56999Z' />
      <path fillRule='evenodd' clipRule='evenodd' d='M6.73663 11.1267V5.77333H7.9033V11.1267H6.73663Z' />
      <path fillRule='evenodd' clipRule='evenodd' d='M10.0833 10.88V5.77333H11.25V10.88H10.0833Z' />
    </svg>
  );
};

export default CartIcon;
